import React from 'react';
import { createIcon } from 'native-base';
import { Path } from 'react-native-svg';
export const QuestionMarkIcon = createIcon({
    viewBox: '0 0 18 18',
    path: (React.createElement(Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM8.25 12.5H9.75V14H8.25V12.5ZM11.3025 8.5L10.6275 9.236C10.0875 9.82 9.75 10.3 9.75 11.5H8.25V11.1C8.25 10.22 8.5875 9.42 9.1275 8.836L10.0575 7.828C10.335 7.54 10.5 7.14 10.5 6.7C10.5 5.82 9.825 5.1 9 5.1C8.175 5.1 7.5 5.82 7.5 6.7H6C6 4.932 7.3425 3.5 9 3.5C10.6575 3.5 12 4.932 12 6.7C12 7.404 11.73 8.044 11.3025 8.5Z" })),
});
